import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RequestCategotyWithTypesModel } from "../../../../shared/models/request/request-categoty-with-types-model";
import { UserEngineerDto } from "../../../../shared/models/User/user-engineer.dto";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { RequestCategoryEnum } from "../../../../shared/enums/request-category.enum";

interface IDay {
    value: Date;
    number: number;
    name: string;
    isDayOff: boolean;
}

@Component({
    selector: 'planning-auto-map-menu',
    templateUrl: './planning-auto-map-menu.component.html',
    styleUrls: [
        './planning-auto-map-menu.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
    ]
})
export class PlanningAutoMapMenuComponent implements OnInit, AfterContentChecked {

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    @Input() userEngineers: UserEngineerDto[] = [];
    @Input() planningLoading: boolean = false;
    @Input() confirmPlanningLoading: boolean = false;
    @Input() confirmPlanningDisabled: boolean = false;

    @Output() changeEngineers: EventEmitter<number[]> = new EventEmitter();
    @Output() cancelPlanningModeEvent: EventEmitter<any> = new EventEmitter();
    @Output() confirmPlanningEvent: EventEmitter<any> = new EventEmitter();

    constructor(
        private changeDetector: ChangeDetectorRef
    ) { }

    ngAfterContentChecked(): void {
        this.initUserEngineers();
    }

    defaultEngineerColor = 'black';
    defaultNotSelectedEngineer: UserEngineerDto = { 
        userId: 0, fullName: 'Не назначен', displayName: 'Не назначен', color: '#465bff', workTimeInMinutes: null, integraCode: null };

    selectedUserEngineerIds: number[] = [];
        
    ngOnInit(): void {
        this.initUserEngineers();
    }

    private initUserEngineers() {
        if (!this.userEngineers.some(x => x.userId == 0)) {
            this.userEngineers.unshift(this.defaultNotSelectedEngineer);
        }
    }

    cancelPlanningMode() {
        this.cancelPlanningModeEvent.emit()
    }

    confirmPlanning() {
        this.confirmPlanningEvent.emit();
    }


    selectEngineer(userId: number) {
        if (this.isSelectedEngineer(userId)) {
            this.selectedUserEngineerIds = this.selectedUserEngineerIds.filter(x => x != userId);
        }
        else {
            this.selectedUserEngineerIds.push(userId);
        }

        this.changeEngineers.emit(this.selectedUserEngineerIds);
    }

    forceSetUserEngineer(userId: number) {
        this.selectedUserEngineerIds = [userId];
        this.changeDetector.detectChanges();
    }

    isSelectedEngineer(userId: number) {
        return this.selectedUserEngineerIds.some(x => x == userId);
    }

    getEngineerColor(engineer: UserEngineerDto): string {
        return engineer.color == null ? this.defaultEngineerColor : engineer.color;
    }

    isEmpty(value: string): boolean {
        return value == null || value.trim() == '';
    }

    isUserHasWorkTime(engineer: UserEngineerDto): boolean {
        return !!engineer.workTimeInMinutes;
    }

    getUserWorkTime(engineer: UserEngineerDto): string {
        const userWorkTime = engineer.workTimeInMinutes;
        const hours = Math.floor(userWorkTime / 60);
        const minutes = userWorkTime % 60;
        let result = `(${hours}ч.`;
        if (minutes !== 0) {
            result += ` ${minutes}мин.`;
        }
        return result += ')';
    }
}